import script from "./AppsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AppsPanel.vue?vue&type=script&setup=true&lang=js"

import "./AppsPanel.vue?vue&type=style&index=0&id=66cc57b0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66cc57b0"]])

export default __exports__